import { render } from "./partnerForm.vue?vue&type=template&id=6afe9c67"
import script from "./partnerForm.vue?vue&type=script&lang=js"
export * from "./partnerForm.vue?vue&type=script&lang=js"

import "./partnerForm.vue?vue&type=style&index=0&id=6afe9c67&lang=css"

import exportComponent from "/builds/sptbr/sysa.ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__